import React, {useEffect, useState} from 'react';
import {Redirect} from '@shopify/app-bridge/actions';
import {createApp} from "@shopify/app-bridge";
import {API_KEY} from "../../App";
import {SHOPIFY_INSTALL_API} from "../../constants/apiUrls";
import {authCheckAPI} from "../../api/axiosRequests";

export default function AuthGate({onAuthSuccess}: any) {
    const [loading, setLoading] = useState(true);
    const params = new URLSearchParams(window.location.search);
    const shop = params.get('shop');
    const host = params.get('host') || '';

    // Initialize App Bridge instance
    const app = createApp({
        apiKey: API_KEY,
        host,
        forceRedirect: true, // Ensures embedding
    });

    useEffect(() => {
        setLoading(true);
        async function authenticate() {
            try {
                // Check if the shop is already registered
                const response = await authCheckAPI(shop);
                if (response.data.authenticated) {
                    // Shop is registered, proceed
                    onAuthSuccess();
                } else {
                    const installUrl = `${process.env.REACT_APP_API_BASE_URL}${SHOPIFY_INSTALL_API}?shop=${shop}&host=${host}`;
                    // Shop is not registered, redirect to install URL
                    const redirect = Redirect.create(app);
                    redirect.dispatch(Redirect.Action.REMOTE, installUrl);
                }
            } catch (error) {
                console.error('Authentication error:', error);
                return <div>An error occurred while authentication.</div>
            } finally {
                setLoading(false);
            }
        }

        (async () => await authenticate())();
    }, [onAuthSuccess]);

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    flexDirection: 'column',
                    fontFamily: 'sans-serif',
                }}
            >
                <div
                    style={{
                        width: 42,
                        height: 42,
                        border: '4px solid rgba(0, 0, 0, 0.1)',
                        borderTop: '4px solid #000',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                    }}
                />
                <p>Authenticating your app...</p>

                <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
            </div>
        );
    }

    return null;
}
